// @ts-nocheck


import { convertFromKopToRub } from '../pure/unitConversions';

export const convertDataFromServer = (
groupedList) => (
{
  ...groupedList,
  actSum: convertFromKopToRub(groupedList.actSum),
  factSum: convertFromKopToRub(groupedList.factSum)
});
